<template>
  <div class="bg-surface-base h-full w-full p-4">
    <div class="xxl:mx-auto xxl:max-w-4xl flex h-full flex-col gap-5">
      <div class="flex shrink-0 flex-col gap-2">
        <div v-if="!hideTitle" class="flex shrink-0 flex-row">
          <h3 class="capitalize-first flex-1 text-2xl font-bold">
            {{ $t('global.activity_log') }}
          </h3>
          <div class="flex shrink-0 flex-row justify-end">
            <UserAvatarPopover
              v-for="causer_id in causerIds"
              :key="causer_id"
              :user-id="causer_id"
            />
          </div>
        </div>
        <div v-if="!hideFilter" class="flex flex-row gap-3 empty:hidden">
          <div v-if="!hideDate" class="w-1/5">
            <BaseShowEditDatePickerv2
              v-model:date="filter.date"
              edition-mode
              :label="$t('attributes.date')"
              :extra-dots="activityDates"
            />
          </div>
          <div v-if="usersForFilter.length > 1" class="w-2/5">
            <SelectComponent
              v-model="filter.users"
              :values="usersForFilter"
              :label="$t('attributes.users')"
              multiple
            />
          </div>
          <div v-if="eventForFilter.length > 1" class="w-2/5">
            <SelectComponent
              v-model="filter.descriptions"
              :values="eventForFilter"
              :label="$t('global.events')"
              multiple
            />
          </div>
          <div v-if="hideTitle" class="flex flex-1 flex-row justify-end">
            <UserAvatarPopover
              v-for="causer_id in causerIds"
              :key="causer_id"
              :user-id="causer_id"
            />
          </div>
        </div>
      </div>
      <div
        v-if="
          Array.isArray(filteredActivities) && filteredActivities.length > 0
        "
        class="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto"
      >
        <ActivityBlock
          v-for="activity in filteredActivities"
          :key="activity.id"
          :activity="activity"
        />
      </div>
      <div v-else-if="loading" class="flex items-center justify-center">
        <LoadingComponent size="small" />
      </div>
      <div v-else class="flex h-full w-full items-center justify-center">
        <h4 class="bg-surface-overlay rounded px-2 py-1 text-xl">
          {{ $t('global.no_results') }}
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatarPopover from '@c/Avatar/Popover/UserAvatarPopover.vue'
import ActivityBlock from '@c/Activity/ActivityBlock.vue'
import { mapGetters } from 'vuex'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import BaseShowEditDatePickerv2 from '@c/addf-package/components/BaseShowEditDatePicker/BaseShowEditDatePickerv2.vue'
import LoadingComponent from '@c/TheLoadingComponent.vue'

export default {
  name: 'ActivityContainer',
  components: {
    LoadingComponent,
    BaseShowEditDatePickerv2,
    SelectComponent,
    ActivityBlock,
    UserAvatarPopover
  },
  props: {
    activities: {
      type: Array,
      required: true
    },
    hideFilter: {
      type: Boolean,
      default: false
    },
    hideDate: {
      type: Boolean,
      default: false
    },
    hideTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filter: {
        users: [],
        descriptions: [],
        date: null
      }
    }
  },
  computed: {
    ...mapGetters({
      users: 'metadata/getAllUserMetadata'
    }),
    filteredActivities() {
      return this.activities.filter((activity) => {
        return (
          (this.filter.users.length == 0 ||
            this.filter.users.includes(activity.causer_id)) &&
          (this.filter.descriptions.length == 0 ||
            this.filter.descriptions.includes(activity.description)) &&
          (this.filter.date === null ||
            activity.created_at.includes(`${this.filter.date}T`))
        )
      })
    },
    causerIds() {
      return [...new Set(this.activities.map((activity) => activity.causer_id))]
    },
    descriptionIds() {
      return [
        ...new Set(this.activities.map((activity) => activity.description))
      ]
    },
    usersForFilter() {
      return this.causerIds.map((id) => {
        return {
          id: id,
          name: this.users(id)?.full_name
        }
      })
    },
    eventForFilter() {
      return this.descriptionIds.map((description) => {
        return {
          id: description,
          name: this.$t(`enums.activityLog.type.${description}`)
        }
      })
    },
    activityDates() {
      return [
        ...new Set(
          this.activities.map((activity) => {
            return activity.created_at.split('T')[0]
          })
        )
      ].map((date) => {
        return {
          color: 'orange',
          date: date
        }
      })
    }
  }
}
</script>
